import { render, staticRenderFns } from "./InstructorUpdate.vue?vue&type=template&id=a0527fa2&"
import script from "./InstructorUpdate.vue?vue&type=script&lang=js&"
export * from "./InstructorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports